import { Dialog as DialogPrimitive } from "radix-ui";

export const DialogRoot = DialogPrimitive.Root;
